export const API_BASE = process.env.BUN_PUBLIC_API_BASE;
